import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'spaq-choose-method',
  templateUrl: './choose-method.component.html',
  styleUrls: ['./choose-method.component.scss'],
})
export class ChooseMethodComponent implements OnInit {

  @Output() selectMethod = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/components/choose-method/choose-method.component.ts